var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisacardIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 39,
    rx: 3.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9467 13.2477L17.4479 26.7884H13.8604L11.1545 15.9823C10.9902 15.3167 10.8474 15.0729 10.3478 14.7924C9.53225 14.3357 8.18519 13.9072 7 13.6412L7.0805 13.2477H12.8553C13.5914 13.2477 14.2531 13.7534 14.4202 14.6283L15.8493 22.4637L19.3812 13.2475H22.9467V13.2477ZM37.0031 22.3673C37.0175 18.7934 32.2151 18.5966 32.2481 17.0001C32.2584 16.5142 32.7066 15.9976 33.6877 15.8658C34.174 15.8001 35.5138 15.75 37.0335 16.4718L37.6296 13.6003C36.813 13.2944 35.7623 13 34.4551 13C31.1006 13 28.7398 14.8405 28.7199 17.476C28.6982 19.4254 30.4049 20.5132 31.6908 21.1609C33.0135 21.8243 33.4574 22.2505 33.4523 22.8439C33.4429 23.7522 32.3973 24.1532 31.4202 24.169C29.7143 24.1961 28.7245 23.6926 27.9355 23.314L27.3203 26.2804C28.1133 26.6559 29.577 26.9835 31.0944 27C34.6601 27.0002 36.9922 25.1825 37.0031 22.3673ZM45.8612 26.7884H49L46.2602 13.2477H43.363C42.7116 13.2477 42.1621 13.6392 41.9188 14.2411L36.8261 26.7884H40.3898L41.0974 24.7657H45.4517L45.8612 26.7884ZM42.0746 21.9905L43.8609 16.9064L44.889 21.9905H42.0746ZM27.7957 13.2477L24.9893 26.7884H21.5957L24.4031 13.2477H27.7957Z",
    fill: "#1434CB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacardIco);
export default __webpack_public_path__ + "static/media/visacard_ico.f7b8a62740f5de71c299502f923e9a61.svg";
export { ForwardRef as ReactComponent };